import React, { useContext, useEffect, useState } from 'react';
import apiUser from '../../../../apiUser';
import { PatrimonioContext } from '../../../../contexts/patrimonioProvider';
import { ItensContext } from '../../../../contexts/ItensProvider';
import { UserContext } from '../../../../contexts/userProvider';
import { ContratosContext } from '../../../../contexts/ContratosProvider';
import SeletorContrato from '../../SeletorContrato';
import { editavelNoItens, rotuloStatusContrato } from './contratoStatus';
import ModalEventoEdicao from './ModalEventoEdicao';
import EventosContrato from './EventosContrato';
import { MSG_ITEM_NOVO_ATIVO, novosDoContrato, sugestaoAditivoItens } from './aditivoItens';

const optionsMonth = [
    { id: '1', nome: 'Janeiro' },
    { id: '2', nome: 'Fevereiro' },
    { id: '3', nome: 'Março' },
    { id: '4', nome: 'Abril' },
    { id: '5', nome: 'Maio' },
    { id: '6', nome: 'Junho' },
    { id: '7', nome: 'Julho' },
    { id: '8', nome: 'Agosto' },
    { id: '9', nome: 'Setembro' },
    { id: '10', nome: 'Outubro' },
    { id: '11', nome: 'Novembro' },
    { id: '12', nome: 'Dezembro' }
];

const defaultItem = {
    descricao: '',
    codigo: '',
    tipo: '',
    quantidade_contratada: '',
    quantidade_implantada: '',
    grupo: '',
    unidade: '',
    valor_unitario: '',
    id_contrato: '',
    fonte_quantidade: 'manual',
    spxo_metrica: null,
    spxo_circuitos: [],
    id_item_vinculo: null,
    razao_vinculo: 1
};

const METRICAS_SPXO = [
    { valor: 'linhas', label: 'Linhas (DIDs)' },
    { valor: 'min_vc1', label: 'Minutos VC1' },
    { valor: 'min_vc2', label: 'Minutos VC2' },
    { valor: 'min_vc3', label: 'Minutos VC3' },
    { valor: 'min_lc', label: 'Minutos Fixo Local' },
    { valor: 'min_ldn', label: 'Minutos Fixo LD' },
];

const EditarItens = ({ client, setClient, handleFecharClick }) => {
    const { grupos } = useContext(PatrimonioContext);
    const { setAlert } = useContext(UserContext);
    const { getItensByClient, itens, loading, setItens, deleteItens, updateItens } = useContext(ItensContext);
    const { contratos, clienteDosContratos, getContratosByClient, reatribuirItens } = useContext(ContratosContext);
    const [itensToDelete, setItensToDelete] = useState([]);
    const [contratoSelecionado, setContratoSelecionado] = useState(null);
    const [circuitosCliente, setCircuitosCliente] = useState([]);
    // Contrato ativo com preço/qtd. contratada alterados: o backend pede o evento (09/out/2026).
    const [pedidoEvento, setPedidoEvento] = useState(null); // null | contratos[] do exige_evento
    const [enviandoEvento, setEnviandoEvento] = useState(false);
    // Item novo em contrato ativo vai por Aditivo de itens (09/out/2026).
    const [recusaAditivo, setRecusaAditivo] = useState(null); // null | contratos[] do exige_aditivo_itens
    const [aditivo, setAditivo] = useState(null); // null | { contrato, itens_novos } — modal de Eventos aberto

    // Circuitos SPXO casados por CNPJ com ESTE cliente (select do item spxo).
    useEffect(() => {
        apiUser.get('/faturamento/spxo/circuitos')
            .then(({ data }) => data.success &&
                setCircuitosCliente(data.dados.filter((c) => Number(c.id_cliente) === Number(client.id))))
            .catch(() => setCircuitosCliente([]));
    }, [client.id]);
    const contratosAtivos = contratos.filter((c) => editavelNoItens(c.status));
    const somenteLeitura = !!contratoSelecionado && !editavelNoItens(contratoSelecionado.status);
    const itensExibidos = contratoSelecionado
        ? (client?.itens || [])
            .map((item, index) => ({ item, index }))
            .filter(({ item }) => String(item.id_contrato) === String(contratoSelecionado.id))
        : [];

    useEffect(() => {
        getItensByClient(client.id);
        getContratosByClient(client.id);
    }, []);

    // A lista global só vale quando pertence a ESTE cliente (provider compartilhado).
    const contratosProntos = Number(clienteDosContratos) === Number(client?.id);

    // Auto-skip: 1 contrato só → seleciona sozinho (decisão do spec).
    useEffect(() => {
        if (contratosProntos && !contratoSelecionado && contratos.length === 1) setContratoSelecionado(contratos[0]);
    }, [contratosProntos, contratos, contratoSelecionado]);

    useEffect(() => {
        let newClient = client;
        newClient.itens = itens || [];
        setClient({ ...newClient });
    }, [itens]);

    const handleItemChange = (index, field, value) => {
        const updatedItens = client.itens?.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setClient({ ...client, itens: updatedItens });
    };

    const addItem = () => {
        const newItem = { ...defaultItem, id_contrato: contratoSelecionado.id };
        const updatedItens = [...(client.itens || []), newItem];
        setClient({ ...client, itens: updatedItens });
    };

    const removeItem = (index) => {
        const updatedItens = client.itens?.filter((_, i) => i !== index);
        const itemToDelete = client.itens?.find((_, i) => i === index);
        if (itemToDelete.id) {
            setItensToDelete([...itensToDelete, itemToDelete.id]);
        }
        setClient({ ...client, itens: updatedItens });
    };

    const handleSaveitens = async () => {
        const itemSemContrato = client.itens?.some((item) => !item.id && !item.id_contrato);
        if (itemSemContrato) {
            setAlert({ visible: true, title: "Atenção!", placeholder: "Selecione o contrato do item", confirm: false, type: "warning" });
            return;
        }

        try {
            const [updatedItens, deleteResponse] = await Promise.all([
                updateItens(client.itens, client.id),
                itensToDelete.length > 0 ? deleteItens(itensToDelete) : Promise.resolve()
            ]);

            let updateSucces = updatedItens?.success;
            let deleteSucces = itensToDelete.length > 0 ? deleteResponse?.success : true;

            // Item novo em contrato ativo: nada foi gravado; oferece o Aditivo de itens.
            if (updatedItens?.exige_aditivo_itens && Array.isArray(updatedItens.contratos)) {
                if (itensToDelete.length > 0 && deleteSucces) setItensToDelete([]);
                setRecusaAditivo(updatedItens.contratos);
                return;
            }

            // Nada dos itens foi gravado: abre o modal do evento e reenvia com ele.
            if (updatedItens?.exige_evento && Array.isArray(updatedItens.contratos)) {
                if (itensToDelete.length > 0 && deleteSucces) setItensToDelete([]);
                setPedidoEvento(updatedItens.contratos);
                return;
            }

            if (itensToDelete.length > 0 && !deleteSucces) {
                setAlert({ visible: true, title: "Atenção!", placeholder: deleteResponse.message, confirm: false, type: "warning" });
            }
            else if (!updateSucces && !deleteSucces) {
                setAlert({ visible: true, title: "Atenção!", placeholder: updatedItens.message, confirm: false, type: "warning" });
            }
            else if (!updateSucces) {
                setAlert({ visible: true, title: "Atenção!", placeholder: updatedItens.message, confirm: false, type: "warning" });
            }
            else if (updateSucces || deleteSucces) {
                setAlert({ visible: true, title: "Sucesso!", placeholder: updatedItens.message, confirm: false, type: "success" });
            }

            handleFecharClick();

        } catch (error) {
            console.error('Erro ao salvar itens:', error);
            setAlert({ visible: true, title: "Atenção!", placeholder: "Erro ao salvar itens", confirm: false, type: "warning" });
        }
    };

    const confirmarEvento = async (evento) => {
        setEnviandoEvento(true);
        try {
            const r = await updateItens(client.itens, client.id, evento);
            if (r?.success) {
                setPedidoEvento(null);
                setAlert({ visible: true, title: "Sucesso!", placeholder: r.message, confirm: false, type: "success" });
                handleFecharClick();
            } else {
                setAlert({ visible: true, title: "Atenção!", placeholder: r?.message || "Erro ao salvar itens", confirm: false, type: "warning" });
            }
        } catch (error) {
            console.error('Erro ao salvar itens com evento:', error);
            setAlert({ visible: true, title: "Atenção!", placeholder: "Erro ao salvar itens", confirm: false, type: "warning" });
        } finally {
            setEnviandoEvento(false);
        }
    };

    const abrirAditivo = (idContrato, itensNovos) => {
        const contrato = contratos.find((c) => String(c.id) === String(idContrato));
        if (!contrato) return;
        setRecusaAditivo(null);
        setAditivo({ contrato, itens_novos: itensNovos ?? sugestaoAditivoItens(client.itens, idContrato).itens_novos });
    };

    // Aditivo lançado: as linhas novas daquele contrato saem do formulário e os itens
    // criados entram na lista sem descartar as outras edições ainda não salvas.
    const aoLancarAditivo = async (lancado) => {
        // Outro tipo lançado pelo mesmo modal: as linhas digitadas continuam aqui.
        if (!lancado || lancado.tipo !== 'aditivo' || lancado.modo !== 'itens') return;
        const idContrato = aditivo.contrato.id;
        setAditivo(null);
        const restantes = (client.itens || []).filter((i) => !(!i.id && String(i.id_contrato) === String(idContrato)));
        let criados = [];
        try {
            const { data } = await apiUser.post('/itens/dados', { id_cliente: client.id });
            const ids = new Set(restantes.map((i) => String(i.id)));
            criados = data.success ? data.dados.filter((i) => !ids.has(String(i.id))) : [];
        } catch (e) { criados = []; }
        setClient({ ...client, itens: [...restantes, ...criados] });
        setAlert({ visible: true, title: "Sucesso!", placeholder: "Aditivo de itens lançado: os itens novos já estão no contrato. Salve as demais alterações, se houver.", confirm: false, type: "success" });
    };

    const contratoAtivo = contratoSelecionado?.status === 'ativo';
    const novosNoAtivo = contratoAtivo ? novosDoContrato(client.itens, contratoSelecionado.id).length : 0;

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-64">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-vox-blue-600"></div>
                <span className="ml-3 text-gray-600 dark:text-gray-400">Carregando...</span>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700">
                <div className="flex items-center space-x-3 mb-4">
                    <span className="text-2xl">📦</span>
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                        Itens do Cliente
                    </h2>
                </div>
                <p className="text-gray-600 dark:text-gray-400">
                    Gerencie os itens contratados por este cliente.
                </p>

                {contratoSelecionado && (
                    <div className="mt-4 flex items-center gap-3">
                        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            Contrato
                        </label>
                        <select
                            value={contratoSelecionado.id}
                            onChange={(e) => {
                                setContratoSelecionado(contratos.find((c) => String(c.id) === e.target.value));
                                // Fila de exclusão é por contexto de contrato — troca de contrato descarta marcações pendentes.
                                setItensToDelete([]);
                            }}
                            className="p-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200"
                        >
                            {contratos.map((c) => (
                                <option key={c.id} value={c.id}>{c.nome}{c.status !== 'ativo' ? ` (${rotuloStatusContrato(c.status)})` : ''}</option>
                            ))}
                        </select>
                    </div>
                )}

                {itensToDelete.length > 0 && contratosAtivos.length > 1 && (
                    <div className="mt-4 flex items-center gap-3">
                        <span className="text-sm text-gray-600 dark:text-gray-400">
                            {itensToDelete.length} item(ns) selecionado(s) para remoção.
                        </span>
                        <select
                            defaultValue=""
                            onChange={(e) => {
                                if (!e.target.value) return;
                                if (window.confirm(`Mover ${itensToDelete.length} item(ns) para o contrato selecionado?`)) {
                                    reatribuirItens(Number(e.target.value), itensToDelete, client.id)
                                        .then((resultado) => {
                                            // Sucesso OU falha: a fila é única (compartilhada com o delete),
                                            // então nunca pode sobrar item de um "mover" pendurado nela —
                                            // falha de mover não pode virar exclusão no próximo save.
                                            // Recarrega para restaurar o estado do servidor (o provider já
                                            // mostrou o alerta de erro/sucesso).
                                            setItensToDelete([]);
                                            getItensByClient(client.id);
                                            // Aviso soft de grupo de equipamento duplicado entre contratos
                                            // ativos: sobrepõe o alerta genérico do provider, mas usa a
                                            // message completa (contagem + aviso) para não perder o "N
                                            // item(ns) movido(s)" que o provider já tinha mostrado.
                                            if (resultado?.avisos?.length) {
                                                setAlert({ visible: true, title: "Atenção!", placeholder: resultado.message || resultado.avisos.join(" "), confirm: false, type: "warning" });
                                            }
                                        });
                                }
                                e.target.value = '';
                            }}
                            className="p-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200"
                        >
                            <option value="">Mover selecionados para…</option>
                            {contratosAtivos.map((c) => (
                                <option key={c.id} value={c.id}>{c.nome}</option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            {!contratosProntos && !contratoSelecionado ? (
                <div className="flex items-center justify-center min-h-64">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-vox-blue-600"></div>
                    <span className="ml-3 text-gray-600 dark:text-gray-400">Carregando contratos...</span>
                </div>
            ) : contratos.length === 0 ? (
                <p className="p-6 text-center text-gray-500 dark:text-gray-400">Cliente sem contratos — crie na aba Contratos.</p>
            ) : !contratoSelecionado ? (
                <SeletorContrato contratos={contratos} onSelecionar={(ct) => {
                    setContratoSelecionado(ct);
                    // Fila de exclusão é por contexto de contrato — troca de contrato descarta marcações pendentes.
                    setItensToDelete([]);
                }} />
            ) : (
            <>
            {/* Lista de itens */}
            <div className="space-y-6">
                {itensExibidos.map(({ item, index }) => (
                    <div key={index} className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                                Item {index + 1}
                            </h3>
                            <button
                                type="button"
                                onClick={() => removeItem(index)}
                                disabled={somenteLeitura}
                                className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200 flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <span className="mr-2">🗑️</span>
                                Remover
                            </button>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            {/* Descrição */}
                            <div className="lg:col-span-3">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Descrição
                                </label>
                                <textarea
                                    value={item.descricao}
                                    onChange={(e) => handleItemChange(index, 'descricao', e.target.value)}
                                    required
                                    disabled={somenteLeitura}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                    rows={3}
                                    placeholder="Descrição do item"
                                />
                            </div>

                            {/* Código */}
                            {/* <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Código
                                </label>
                                <input
                                    type="text"
                                    value={item.codigo}
                                    onChange={(e) => handleItemChange(index, 'codigo', e.target.value)}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200"
                                    placeholder="Código do item"
                                />
                            </div> */}

                            {/* Tipo */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Tipo
                                </label>
                                <select
                                    value={item.tipo}
                                    onChange={(e) => handleItemChange(index, 'tipo', e.target.value)}
                                    required
                                    disabled={somenteLeitura}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    <option value="">Selecione o tipo</option>
                                    <option value="Equipamento">Equipamento</option>
                                    <option value="Licença">Licença</option>
                                    <option value="Linhas">Linhas</option>
                                    <option value="Serviço">Serviço</option>
                                    <option value="Minutos">Minutos</option>
                                    <option value="Valor">Valor</option>
                                </select>
                            </div>

                            {/* Fonte da quantidade (spec integracao-spxo) */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Fonte da quantidade
                                </label>
                                <select
                                    value={item.fonte_quantidade || (item.tipo === 'Equipamento' ? 'patrimonio' : 'manual')}
                                    onChange={(e) => handleItemChange(index, 'fonte_quantidade', e.target.value)}
                                    disabled={somenteLeitura}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    <option value="manual">Manual</option>
                                    <option value="patrimonio">Patrimônio (contagem por grupo)</option>
                                    <option value="spxo">SPXO (SaperX)</option>
                                </select>
                            </div>

                            {(item.fonte_quantidade === 'spxo') && (
                                <>
                                    {/* Métricas SPXO (multi-seleção; CSV no campo) */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                            Métricas SPXO (uma ou mais)
                                        </label>
                                        <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-2 space-y-1 bg-white dark:bg-gray-700">
                                            {METRICAS_SPXO.map((m) => {
                                                const selecionadas = String(item.spxo_metrica || '').split(',').map((x) => x.trim()).filter(Boolean);
                                                const marcado = selecionadas.includes(m.valor);
                                                return (
                                                    <label key={m.valor} className="flex items-center gap-2 text-sm text-gray-800 dark:text-gray-200">
                                                        <input
                                                            type="checkbox"
                                                            checked={marcado}
                                                            disabled={somenteLeitura}
                                                            onChange={() => {
                                                                const novas = marcado
                                                                    ? selecionadas.filter((x) => x !== m.valor)
                                                                    : [...selecionadas, m.valor];
                                                                handleItemChange(index, 'spxo_metrica', novas.join(',') || null);
                                                            }}
                                                        />
                                                        {m.label}
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* Circuitos SPXO */}
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                            Circuitos SPXO (vazio = todos os circuitos do cliente)
                                        </label>
                                        {circuitosCliente.length === 0 ? (
                                            <p className="text-sm text-yellow-700 dark:text-yellow-400">
                                                Nenhum circuito casado por CNPJ com este cliente — sincronize na aba SPXO do Faturamento.
                                            </p>
                                        ) : (
                                            <div className="max-h-40 overflow-y-auto border border-gray-300 dark:border-gray-600 rounded-lg p-2 space-y-1 bg-white dark:bg-gray-700">
                                                {circuitosCliente.map((c) => {
                                                    const marcado = (item.spxo_circuitos || []).includes(c.id_sip);
                                                    return (
                                                        <label key={c.id_sip} className="flex items-center gap-2 text-sm text-gray-800 dark:text-gray-200">
                                                            <input
                                                                type="checkbox"
                                                                checked={marcado}
                                                                disabled={somenteLeitura}
                                                                onChange={() => {
                                                                    const atual = item.spxo_circuitos || [];
                                                                    handleItemChange(index, 'spxo_circuitos',
                                                                        marcado ? atual.filter((s) => s !== c.id_sip) : [...atual, c.id_sip]);
                                                                }}
                                                            />
                                                            {c.nome} <span className="text-gray-400">(sip {c.id_sip})</span>
                                                        </label>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}

                            {/* Contrato (informativo — reatribuição é só via "Mover selecionados para…") */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Contrato
                                </label>
                                <p className="w-full p-3 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-900 text-gray-700 dark:text-gray-300">
                                    {contratos.find((c) => String(c.id) === String(item.id_contrato))?.nome || contratoSelecionado?.nome || '—'}
                                </p>
                            </div>

                            {/* Licença vinculada (spec 2026-10-09): segue a quantidade do item que a exige, até o contratado */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Exigida por
                                </label>
                                <select
                                    value={item.id_item_vinculo ?? ''}
                                    onChange={(e) => handleItemChange(index, 'id_item_vinculo', e.target.value ? Number(e.target.value) : null)}
                                    disabled={somenteLeitura}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    <option value="">Nenhum (quantidade própria)</option>
                                    {itensExibidos
                                        .filter(({ item: outro }) => outro.id && outro.id !== item.id)
                                        .map(({ item: outro }) => (
                                            <option key={outro.id} value={outro.id}>
                                                {String(outro.descricao || '').slice(0, 70)}{outro.tipo ? ` (${outro.tipo})` : ''}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            {item.id_item_vinculo ? (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                        Licenças por unidade
                                    </label>
                                    <input
                                        type="number"
                                        min="0.01"
                                        step="0.01"
                                        value={item.razao_vinculo ?? 1}
                                        onChange={(e) => handleItemChange(index, 'razao_vinculo', e.target.value)}
                                        disabled={somenteLeitura}
                                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                    />
                                    <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                                        Cobra o maior entre a quantidade digitada e (item × licenças por unidade), até a quantidade contratada.
                                    </p>
                                </div>
                            ) : null}

                            {/* Valor Unitário */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Valor Unitário
                                </label>
                                <input
                                    type="text"
                                    value={item.valor_unitario}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(',', '.');
                                        if (!isNaN(val)) handleItemChange(index, 'valor_unitario', val)
                                    }}
                                    required
                                    disabled={somenteLeitura}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                    placeholder="0,00"
                                />
                            </div>


                            {/* Grupo */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Grupo
                                </label>
                                <select
                                    value={item.grupo}
                                    onChange={(e) => handleItemChange(index, 'grupo', e.target.value)}
                                    required
                                    disabled={somenteLeitura}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    <option value="">Selecione um grupo</option>
                                    {grupos.map((grupo, i) => (
                                        <option key={i} value={grupo.id}>
                                            {grupo.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Unidade */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Unidade
                                </label>
                                <select
                                    value={item.unidade}
                                    onChange={(e) => {
                                        const updatedItens = client.itens?.map((item, i) =>
                                            i === index ? { ...item, unidade: e.target.value, quantidade_contratada: '' } : item
                                        );
                                        setClient({ ...client, itens: updatedItens });
                                    }}
                                    required
                                    disabled={somenteLeitura}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                >
                                    <option value="">Selecione a unidade</option>
                                    <option value="Mês">Mês</option>
                                    <option value="Unitário">Unitário</option>
                                    <option value="Minutos">Minutos</option>
                                    <option value="Única">Única</option>
                                </select>
                            </div>
                            {/* Quantidade Contratada */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    {item.unidade === 'Única' ? 'Mês' : 'Quantidade Contratada'}
                                </label>
                                {item.unidade === 'Única' ? (
                                    <select
                                        value={item.quantidade_contratada}
                                        onChange={(e) => handleItemChange(index, 'quantidade_contratada', e.target.value)}
                                        required
                                        disabled={somenteLeitura}
                                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                    >
                                        <option value="">Selecione o mês</option>
                                        {optionsMonth.map((month) => (
                                            <option key={month.id} value={month.id}>
                                                {month.nome}
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type="number"
                                        value={item.quantidade_contratada}
                                        onChange={(e) => !isNaN(e.target.value) && handleItemChange(index, 'quantidade_contratada', e.target.value)}
                                        required
                                        disabled={somenteLeitura}
                                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-vox-blue-500 focus:border-vox-blue-500 transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                        placeholder=""
                                    />
                                )}
                            </div>

                        </div>
                    </div>
                ))}
            </div>

            {contratoAtivo && (
                <div role="note" className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/30 dark:text-amber-100">
                    {MSG_ITEM_NOVO_ATIVO} Use <b>Lançar aditivo de itens</b>
                    {novosNoAtivo > 0 ? ` — o item digitado aqui (${novosNoAtivo}) vai preenchido no aditivo.` : '.'}
                </div>
            )}

            {/* Botões de ação */}
            <div className="flex flex-col sm:flex-row gap-3 pt-6 border-t border-gray-200 dark:border-gray-700">
                {contratoAtivo && (
                    <button
                        type="button"
                        onClick={() => abrirAditivo(contratoSelecionado.id)}
                        className="flex-1 sm:flex-none px-6 py-3 bg-vox-green-600 hover:bg-vox-green-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
                    >
                        <span className="mr-2">📝</span>
                        Lançar aditivo de itens
                    </button>
                )}
                {!somenteLeitura && (
                    <button
                        type="button"
                        onClick={addItem}
                        className="flex-1 sm:flex-none px-6 py-3 bg-vox-green-600 hover:bg-vox-green-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
                    >
                        <span className="mr-2">➕</span>
                        Adicionar Item
                    </button>
                )}

                <button
                    type="button"
                    onClick={handleSaveitens}
                    disabled={somenteLeitura}
                    className="flex-1 sm:flex-none px-6 py-3 bg-vox-blue-600 hover:bg-vox-blue-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <span className="mr-2">💾</span>
                    Salvar Itens
                </button>

                <button
                    type="button"
                    onClick={handleFecharClick}
                    className="flex-1 sm:flex-none px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
                >
                    <span className="mr-2">✕</span>
                    Fechar
                </button>
            </div>
            </>
            )}
            {pedidoEvento && (
                <ModalEventoEdicao contratos={pedidoEvento} enviando={enviandoEvento}
                    onConfirmar={confirmarEvento} onCancelar={() => setPedidoEvento(null)} />
            )}
            {recusaAditivo && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="fixed inset-0 bg-black/50" onClick={() => setRecusaAditivo(null)} />
                    <div role="dialog" aria-modal="true" aria-labelledby="recusa-aditivo-titulo"
                        className="relative w-full max-w-lg rounded-lg bg-white p-6 shadow-xl dark:bg-gray-800">
                        <h3 id="recusa-aditivo-titulo" className="text-lg font-semibold text-gray-900 dark:text-white">Item novo em contrato ativo</h3>
                        <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
                            {MSG_ITEM_NOVO_ATIVO} Nada foi salvo.
                        </p>
                        <ul className="mt-4 space-y-3">
                            {recusaAditivo.map((c) => (
                                <li key={c.id_contrato} className="flex items-center justify-between gap-3 rounded-lg border border-gray-200 p-3 dark:border-gray-700">
                                    <div className="text-sm text-gray-700 dark:text-gray-300">
                                        <p className="font-medium text-gray-900 dark:text-white">{c.nome}</p>
                                        <p>{c.itens_novos.length} item(ns) preenchido(s) no aditivo
                                            {c.nao_simples > 0 ? ` · ${c.nao_simples} com SPXO, patrimônio ou vínculo: lance à mão` : ''}</p>
                                    </div>
                                    <button type="button" onClick={() => abrirAditivo(c.id_contrato, c.itens_novos)}
                                        className="shrink-0 rounded-lg bg-vox-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-vox-green-700">
                                        Lançar aditivo de itens
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-6 flex justify-end">
                            <button type="button" onClick={() => setRecusaAditivo(null)}
                                className="rounded-lg bg-gray-500 px-4 py-2 text-sm font-medium text-white hover:bg-gray-600">
                                Voltar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {aditivo && (
                <EventosContrato contrato={aditivo.contrato} client={client} aditivoInicial={aditivo.itens_novos}
                    onClose={() => setAditivo(null)} onMudou={aoLancarAditivo} />
            )}
        </div>
    );
};

export default EditarItens;